<template>
  <div class="form-content">
    <van-form>
      <div
        v-show="isShowFiled('holderName')||isShowFiled('holderIdNo')||isShowFiled('holderMobile')"
      >
        <div class="header-box">
          <i class="header-icon"></i>
          <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
          <label class="header-name">投保人基本信息(父母)</label>
        </div>
        <van-field
          v-show="isShowFiled('holderName')"
          v-model="dataForm.holderName"
          name="姓名"
          :label="getFiledName('holderName')"
          :placeholder="getPlaceHolderName('holderName')"
        />
        <van-field
          v-show="isShowFiled('holderIdNo')"
          v-model="dataForm.holderIdNo"
          name="身份证号"
          :label="getFiledName('holderIdNo')"
          :placeholder="getPlaceHolderName('holderIdNo')"
        />
        <van-field
          v-show="isShowFiled('holderMobile')"
          v-model="dataForm.holderMobile"
          name="手机号"
          :label="getFiledName('holderMobile')"
          :placeholder="getPlaceHolderName('holderMobile')"
        />
      </div>
      <div class="header-box">
        <i class="header-icon"></i>
        <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
        <label class="header-name">被保人信息孩子</label>
      </div>
      <van-field
        v-show="isShowFiled('insureName')"
        v-model="dataForm.insureName"
        name="姓名"
        :label="getFiledName('insureName')"
        :placeholder="getPlaceHolderName('insureName')"
      />
      <van-field
        v-show="isShowFiled('insureIdNo')"
        v-model="dataForm.insureIdNo"
        name="身份证号码"
        :label="getFiledName('insureIdNo')"
        :placeholder="getPlaceHolderName('insureIdNo')"
      />
      <van-field
        v-show="isShowFiled('insureMobile')"
        v-model="dataForm.insureMobile"
        name="联系方式"
        :label="getFiledName('insureMobile')"
        :placeholder="getPlaceHolderName('insureMobile')"
      />
      <van-field
        v-show="isShowFiled('school')"
        v-model="dataForm.school"
        name="学校"
        :label="getFiledName('school')"
        :placeholder="getPlaceHolderName('school')"
      />
      <template>
        <van-field
          v-show="isShowFiled('grade')"
          v-model="dataForm.grade"
          name="年级"
          :label="getFiledName('grade')"
          :placeholder="getPlaceHolderName('grade')"
        />
        <van-field
          v-show="isShowFiled('gradeClass')"
          v-model="dataForm.gradeClass"
          name="班级"
          :label="getFiledName('gradeClass')"
          :placeholder="getPlaceHolderName('gradeClass')"
        />
      </template>
      <div class="header-box">
        <i class="header-icon"></i>
        <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
        <label class="header-name">保障信息</label>
      </div>
      <van-field v-model="premiumYear" name="保障期限" label="保障期限" readonly />
      <van-field v-model="forceTimeName" name="生效日期" label="生效日期" readonly />
      <div class="money-box">
        <van-field v-model="premiumValue" name="保费" label="保费" readonly />
      </div>
    </van-form>
    <div class="check-box" v-if="showHolder">
      <van-checkbox v-model="checked" shape="square" icon-size="20px">我已阅读并确认</van-checkbox>
      <!--      <div style="display: flex;flex-direction: column;" v-if="showHolder">-->
      <!--        <label class="link-book" @click="handleShowBlookClick(3)">《致学生家长的一封信》</label>-->
      <!--      </div>-->
      <div style="display: flex;flex-direction: column;">
        <label
          class="link-book"
          @click="handleShowBlookClick(item.value)"
          v-for="(item,idx) in authorize"
          :key="idx"
        >{{item.name}}</label>
        <!--        <label class="link-book" @click="handleShowBlookClick(2)">《2020年方案(确认书)》</label>-->
        <!--        <label class="link-book" @click="handleShowBlookClick(3)">《致学生家长的一封信》</label>-->
      </div>
    </div>
    <div style="height:5rem"></div>
    <div class="button-save" v-show="!$ComTools.isEmptyString(categoryId)">
      <van-button
        @click="checked?handleGoClick():plaseCheck()"
        type="primary"
        block
        :color="checked?'#FFC281':'#C0C0C0'"
      >前往支付</van-button>
    </div>
    <van-dialog v-model="showDlg" title="扫描关注东方保险经纪公众号" @confirm="handleConfirmClick">
      <img style="width:100%" src="http://nywx.e-ibdt.cn/file/QRCode/weixin/weixin-e-ib.png" />
    </van-dialog>
  </div>
</template>

<script>
import { Toast, Notify } from "vant";
import { isMobile, isCard } from "@/utils/validate";
import {
  insureCreateInsure,
  getJsapiTicket,
  findCategoryById,
} from "@/api/common";

export default {
  data() {
    return {
      showDlg: false,
      dataForm: {
        gradeClass: "",
        holderName: "",
        holderIdNo: "",
        holderMobile: "",
        insureName: "",
        insurantCardType: 1,
        insureIdNo: "",
        insureMobile: "",
        school: "",
        grade: "",
        categoryId: "",
        belongerId: "",
        platformId: "",
      },
      categoryId: "",
      premiumValue: "100元",
      premiumYear: "1年",
      forceTimeName: "",
      checked: false,
      showHolder: true,
      filedOptions: {},
      authorize: [],
    };
  },
  activated() {
    document.title = "学生 幼儿意外伤害保险(学平险)";
    this.categoryId = this.$route.query.categoryId || "";
    this.dataForm.categoryId = this.categoryId;
    this.dataForm.belongerId = this.$route.query.belongerId || "";
    this.dataForm.platformId = this.$route.query.platformId || "";
    // if (this.categoryId == "121") {
    //   this.dataForm.school = "禾佳幼儿园";
    //   this.checked = true;
    // }
    // switch (this.categoryId) {
    //   case "133":
    //     this.premiumValue = "50元";
    //     break;
    //   case "104":
    //     this.dataForm.school = "禾佳幼儿园";
    //     this.checked = true;
    //     break;
    //   case "116":
    //     this.premiumValue = "50元";
    //     break;
    //   case "117":
    //     this.premiumValue = "150元";
    //     break;
    // }
    this._findCategoryById();
    this.initShare();
    let categoryGroup = ["112", "116", "117", "132", "133"];
    this.showHolder = !(
      this.categoryId && categoryGroup.indexOf(this.categoryId) == -1
    );
  },
  methods: {
    initShare() {
      let sUrl = location.href.split("#")[0];
      let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_picc.png";
      getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
        if (res.code === 0) {
          this.$ComTools.wxShare(
            res.data,
            sUrl,
            sImgUrl,
            "中国人保学平险互联网投保",
            "学生、幼儿意外伤害保险方案 意外伤害、疾病、多重风险保障"
          );
        }
      });
    },
    _findCategoryById() {
      this.filedOptions = {};
      findCategoryById({ id: this.categoryId }).then((res) => {
        this.authorize = this.$ComTools.isEmptyString(res.data.authorize)
          ? []
          : JSON.parse(res.data.authorize);
        let data = res.data;
        this.premiumValue = data.premium + "元";
        this.premiumYear = data.periodNumber + "年";
        this.showHolder = this.$ComTools.isEmptyString(data.authorize)
          ? false
          : true;
        this.checked = this.$ComTools.isEmptyString(data.authorize)
          ? true
          : false;
        if (
          !this.$ComTools.isEmptyString(data.startTime) &&
          !this.$ComTools.isEmptyString(data.endTime)
        ) {
          this.forceTimeName =
            this.$DateTools.formatDatetime(
              "yyyy年MM月dd日",
              new Date(data.startTime)
            ) +
            "-" +
            this.$DateTools.formatDatetime(
              "yyyy年MM月dd日",
              new Date(data.endTime)
            );
        } else {
          const that = this;
          this.forceTimeName =
            this.$DateTools.formatDatetime(
              "yyyy年MM月dd日",
              this.$DateTools.getDateByDay(data.startNumber)
            ) +
            "-" +
            this.$DateTools.changeDate(
              this.$DateTools.getDateByDay(1),
              "YEAR",
              data.periodNumber,
              null,
              "yyyy年MM月dd日"
            );
        }
        let sFileds = data.fieldJson;
        if (!this.$ComTools.isEmptyString(sFileds)) {
          let aFileds = JSON.parse(sFileds);
          for (let i = 0; i < aFileds.length; i++) {
            let obj = aFileds[i];
            let sKey = obj.key;
            let oValue = this.filedOptions[sKey];
            if (this.$ComTools.isEmptyString(oValue)) {
              this.filedOptions[sKey] = obj;
            }
          }
        }
        this.$forceUpdate();
      });
    },
    //判断是否展示该字段
    isShowFiled(key) {
      let obj = this.filedOptions[key];
      if (!this.$ComTools.isEmptyString(obj)) {
        if (obj.write == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isNeedVerify(key) {
      let obj = this.filedOptions[key];
      if (!this.$ComTools.isEmptyString(obj)) {
        if (obj.write == 1 && obj.required == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    //获取动态字段名称
    getFiledName(key) {
      let obj = this.filedOptions[key];
      if (!this.$ComTools.isEmptyString(obj)) {
        let sDefaultValue = obj.defaultValue || "";
        if (!this.$ComTools.isEmptyString(sDefaultValue)) {
          this.dataForm[key] = sDefaultValue;
        }
        return obj.name;
      } else {
        return "";
      }
    },
    //获取动态字段名称
    getPlaceHolderName(key) {
      let obj = this.filedOptions[key];
      if (!this.$ComTools.isEmptyString(obj)) {
        return obj.placeholder;
      } else {
        return "";
      }
    },
    handleShowBlookClick(path) {
      this.$router.push({
        path: path,
        // query: { categoryId: this.categoryId }
      });
    },
    plaseCheck() {
      alert("请阅读并勾选协议");
    },
    handleGoClick() {
      if (
        this.isNeedVerify("holderName") &&
        this.$ComTools.isEmptyString(this.dataForm.holderName)
      ) {
        return Toast("请输入姓名");
      }
      if (
        this.isNeedVerify("holderIdNo") &&
        this.$ComTools.isEmptyString(this.dataForm.holderIdNo)
      ) {
        return Toast("请输入身份证号");
      }
      if (
        this.isNeedVerify("holderIdNo") &&
        !isCard(this.dataForm.holderIdNo)
      ) {
        return Toast("身份证号码错误请检查");
      }
      if (
        this.isNeedVerify("holderMobile") &&
        this.$ComTools.isEmptyString(this.dataForm.holderMobile)
      ) {
        return Toast("请输入手机号");
      }
      if (
        this.isNeedVerify("holderMobile") &&
        !isMobile(this.dataForm.holderMobile)
      ) {
        return Toast("手机号格式错误");
      }
      if (
        this.isNeedVerify("insureMobile") &&
        this.$ComTools.isEmptyString(this.dataForm.insureMobile)
      ) {
        return Toast("请输入手机号");
      }
      if (
        this.isNeedVerify("insureMobile") &&
        this.$ComTools.isEmptyString(this.dataForm.insureMobile)
      ) {
        return Toast("手机号错误请检查");
      }

      if (
        this.isNeedVerify("insureName") &&
        this.$ComTools.isEmptyString(this.dataForm.insureName)
      ) {
        return Toast("请输入姓名");
      }
      if (
        this.isNeedVerify("insureIdNo") &&
        this.$ComTools.isEmptyString(this.dataForm.insureIdNo)
      ) {
        return Toast("请输入身份证号");
      }
      if (
        this.isNeedVerify("insureIdNo") &&
        !isCard(this.dataForm.insureIdNo)
      ) {
        return Toast("身份证号码错误请检查");
      }
      if (
        this.isNeedVerify("school") &&
        this.$ComTools.isEmptyString(this.dataForm.school)
      ) {
        return Toast("请输入学校");
      }
      if (
        this.isNeedVerify("grade") &&
        this.$ComTools.isEmptyString(this.dataForm.grade)
      ) {
        return Toast("请输入年级");
      }
      if (
        this.isNeedVerify("gradeClass") &&
        this.$ComTools.isEmptyString(this.dataForm.gradeClass)
      ) {
        return Toast("请输入班级");
      }
      Toast.loading({
        message: "支付中...",
        forbidClick: true,
        duration: 0,
      });
      insureCreateInsure(this.dataForm).then((res) => {
        Toast.clear();
        if (res.code === 0) {
          var paymentMap = res.data;
          if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.$ComTools.onBridgeReady(paymentMap, this.payCallback),
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent(
                "WeixinJSBridgeReady",
                this.$ComTools.onBridgeReady(paymentMap, this.payCallback)
              );
              document.attachEvent(
                "onWeixinJSBridgeReady",
                this.$ComTools.onBridgeReady(paymentMap, this.payCallback)
              );
            }
          } else {
            this.$ComTools.onBridgeReady(paymentMap, this.payCallback);
          }
        } else {
          Notify({ type: "danger", message: res.msg });
        }
      });
    },
    payCallback(index) {
      switch (index) {
        case 1:
          this.showDlg = true;
          break;
        case 2:
          Toast("取消支付");
          WeixinJSBridge.call("closeWindow");
          break;
        case 3:
          Toast("支付失败");
          WeixinJSBridge.call("closeWindow");
          break;
      }
    },
    handleConfirmClick() {
      this.showDlg = false;
      this.$router.push({
        path: "/insure/list",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-content {
  width: 100%;
  min-height: 100%;

  .header-box {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.8rem;

    .header-icon {
      background-color: #ffc281;
      height: 1.4rem;
      width: 5px;
      display: block;
      margin-right: 0.5rem;
    }

    .header-img {
      width: 1.3rem;
      margin: 0 0.5rem;
    }

    .header-name {
      font-size: 1rem;
      font-weight: 600;
    }
  }

  .money-box {
    /deep/ .van-field__control {
      color: #ff002f;
      font-size: 1.3rem;
    }
  }

  .check-box {
    width: 100%;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;

    /deep/ .van-checkbox__label {
      color: gray;
      font-size: 0.8rem;
    }

    .link-book {
      color: #317cf8;
      font-size: 0.8rem;
    }
  }
}

.button-save {
  /deep/ .van-button {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    // color: black !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/student_form.vue